import Vue from 'vue';
import axios from 'axios';
import moment from 'moment';
import Loading from 'vue-loading-overlay';
import 'vue-loading-overlay/dist/vue-loading.css';
import BootstrapVue from 'bootstrap-vue';
import 'bootstrap-vue/dist/bootstrap-vue.css';
import Multiselect from 'vue-multiselect';
import 'vue-multiselect/dist/vue-multiselect.min.css';
import VueRouter from 'vue-router';
import Snotify from 'vue-snotify';
import 'vue-snotify/styles/material.css'
import { HorizontalBar  } from 'vue-chartjs'
import { Doughnut } from 'vue-chartjs'
import { Bar } from 'vue-chartjs'
import { Line } from 'vue-chartjs'
import 'chart.piecelabel.js';
import PulseLoader from 'vue-spinner/src/PulseLoader.vue'
import ToggleButton from 'vue-js-toggle-button'
import { max } from 'moment';
import fishList from '../data/fishList.js';
import { colors, months, monthNumbers, multiSelectOptions, colorPalete } from '../data/constants.js'

Vue.use(Loading);
Vue.use(Snotify);
Vue.use(ToggleButton);

//#region Components
Vue.component('multiselect', Multiselect);

Vue.component('hor-bar-chart', {
    extends: HorizontalBar,
    props: ['data', 'options'],
    mounted() {
        // this.chartData is created in the mixin
        this.renderChart(this.data, this.options)
    },
    methods: {
        handle(point, event) {
            const item = event[0]
            this.$emit('on-receive', {
                index: item._index,
                backgroundColor: item._view.backgroundColor,
                value: this.values[item._index]
            })
        }
    },
    watch: {
        data: function () {
            this._data._chart.destroy();
            this.renderChart(this.data, this.options);
        }
    },
})

Vue.component('bar-chart', {
    extends: Bar,
    props: ['data', 'options'],
    mounted() {
        // this.chartData is created in the mixin
        this.renderChart(this.data, this.options)
    },
    methods: {
        handle(point, event) {
            const item = event[0]
            this.$emit('on-receive', {
                index: item._index,
                backgroundColor: item._view.backgroundColor,
                value: this.values[item._index]
            })
        }
    },
    watch: {
        data: function () {
            this._data._chart.destroy();
            this.renderChart(this.data, this.options);
        }
    },
})

Vue.component('line-chart', {
    extends: Line,
    props: ['data', 'options'],
    mounted() {
        // this.chartData is created in the mixin
        this.renderChart(this.data, this.options)
    },
    methods: {
        handle(point, event) {
            const item = event[0]
            this.$emit('on-receive', {
                index: item._index,
                backgroundColor: item._view.backgroundColor,
                value: this.values[item._index]
            })
        }
    },
    watch: {
        data: function () {
            this._data._chart.destroy();
            this.renderChart(this.data, this.options);
        }
    },
})

Vue.component('pie-chart', {
    extends: Doughnut,
    props: ['data', 'options'],
    mounted() {
        // this.chartData is created in the mixin
        this.renderChart(this.data, this.options)
    },
    watch: {
        data: function () {
            this._data._chart.destroy();
            this.renderChart(this.data, this.options);
        }
    },
    methods: {
        handle(point, event) {
            const item = event[0]
            this.$emit('on-receive', {
                index: item._index,
                backgroundColor: item._view.backgroundColor,
                value: this.values[item._index]
            })
        }
    }
})

Vue.filter('scaleArray', function (array, initScale = 0 ) {
    var maxValue = Math.max(...array);
    var parts = maxValue.toString().split('.');
    var scale = initScale > 0? initScale : parts[0].length;
    var devider = 1;
    var text = 'NOK'
    switch (true) {
        case scale > 3 && scale <= 6:
            devider = Math.pow(10, 3);
            text = 'TUSEN NOK'
            break;
        case scale <= 9:
            devider = Math.pow(10, 6);
            text = 'MILL NOK'
            break;
        case scale > 9:
            devider = Math.pow(10, 9);
            text = 'MRD NOK'
            break;
        default:
    }
    var scaledArray = array.map(el => parseFloat(el / devider ).toFixed(2))

    return {
        Array: scaledArray,
        Text: text,
        Scale: scale
    };
});

//#endregion

//#region Filters
Vue.filter('toKilo', function (value) {
    return Math.round(value / 1000).toString();
});

Vue.filter('toMega', function (value) {
    return Math.round(value / 1000000).toString();
});

Vue.filter('toMegaDecimal', function (value) {
    return parseFloat(value / 1000000).toFixed(1).toString();
});

Vue.filter('toGiga', function (value) {
    return parseFloat(value / 1000000000).toFixed(1).toString();
});

Vue.filter('separator', function (value) {
    try {
        return value.toString().replace(/\B(?=(\d{3})+(?!\d))/g, ' ');
    } catch (e) {
        return value;
    }
});

Vue.filter('round', function (value) {
    if (value) {
        return Math.round(value).toString();
    }
    return value;
});

Vue.filter('formatPercentage', function (value) {
    if (Math.abs(value) >= 1000) {
        return '';
    }
    if (value > 0) {
        return '+' + value + '%';
    }
    return value + '%';
});

Vue.filter('formatYear', function (value) {
    if (moment().year() === value) {
        return 'Hittil i år';
    }
    return value;
});
//#endregion

var app = new Vue({
    el: '#statisticOverview',
    components: {
        PulseLoader
    },

    data: {
        colors,

        dateRange: {end: moment().format("YYYYMMDD"),
        start: moment().subtract(4, 'years').startOf("year").format("YYYYMMDD") },

        years: Array.from({ length: 4 }, (_, i) => new Date().getFullYear() - i),

        fishOptions: fishList,
        selectedFish: null,
        fishOptionsLoading: false,

        conditionOptions: [],
        selectedCondition: null,
        fishConditionsLoading: false,

        conservationOptions: [],
        selectedConservation: null,
        conservationOptionsLoading: false,

        weightOptions: [],
        selectedWeight: null,
        weightOptionsLoading: false,

        qualityOptions: [],
        selectedQuality: null,
        qualityOptionsLoading: false,

        areaOptions: [],
        selectedArea: null,
        areaOptionsLoading: false,

        gearOptions: [],
        selectedGear: null,
        gearOptionsLoading: false,

        quotaOptions: [],
        selectedQuota: null,
        quotaOptionsLoading: false,

        showYTDData: false,

        isLoading: true,

        isMobileScreen: window.innerWidth < 576 ? true : false,

        fishDataArray: [],

        gearDataArray: [],

        dynamicBarLabels: [],
        dynamicBarData: [],
        dynamicBarLYData: [],
        dynamicBarColors: [],

        dynamicPieLabels: [],
        dynamicPieData: [],
        dynamicPieColors: [],

        fishValueChartOptions: {
            scales: {
                yAxes: [{
                    ticks: {
                        beginAtZero: true
                    },
                    gridLines: {
                        display: false
                    }
                }],
                xAxes: [{
                    ticks: {
                        beginAtZero: true
                    },
                    gridLines: {
                        display: false
                    },
                }]
            },
            legend: {
                display: true,
                position: 'top',
                labels: {
                    usePointStyle: true,
                    fontFamily: 'Open Sans',
                    fontSize: window.innerWidth >= 768 ? 14 : 12,
                    pointStyle: 'circle'
                }
            },
            tooltips: {
                enabled: true,
                mode: 'single',
                displayColors: false,
                titleFontFamily: 'Open Sans',
                titleFontSize: 16,
                titleAlign: 'right',
                bodyFontFamily: 'Open Sans',
                bodyFontSize: 30,
                bodyFontColor: colorPalete.pri,
                bodyFontStyle: 'bold',
                bodyAlign: 'right',
                footerFontFamily: 'Open Sans',
                footerColor: '#fff',
                footerAlign: 'right',
                caretSize: 10,
                callbacks: {
                    label: function (tooltipItems, data) {
                        return parseFloat(tooltipItems.yLabel).toFixed(2);
                    },
                    footer: function () {
                        return ' NOK';
                    }
                }
            },
            responsive: true,
            maintainAspectRatio: false,
            height: 200
        },

        fishWeightChartOptions: {
            scales: {
                yAxes: [{
                    ticks: {
                        beginAtZero: true,
                        callback: function (value, index, values) {
                            try {
                                return value.toString().replace(/\B(?=(\d{3})+(?!\d))/g, ' ');
                            } catch (e) {
                                return value;
                            }
                        }
                    },
                    gridLines: {
                        display: false
                    }
                }],
                xAxes: [{
                    ticks: {
                        beginAtZero: true
                    },
                    gridLines: {
                        display: false
                    },
                }]
            },
            legend: {
                display: true,
                position: 'top',
                labels: {
                    usePointStyle: true,
                    fontFamily: 'Open Sans',
                    fontSize: window.innerWidth >= 768 ? 14 : 12,
                    pointStyle: 'circle'
                }
            },
            tooltips: {
                enabled: true,
                mode: 'single',
                displayColors: false,
                titleFontFamily: 'Open Sans',
                titleFontSize: 16,
                titleAlign: 'right',
                bodyFontFamily: 'Open Sans',
                bodyFontSize: 30,
                bodyFontColor: colorPalete.priGold,
                bodyFontStyle: 'bold',
                bodyAlign: 'right',
                footerFontFamily: 'Open Sans',
                footerColor: '#fff',
                footerAlign: 'right',
                caretSize: 10,
                callbacks: {
                    title: function (tooltipItem, data) {
                        return data['labels'][tooltipItem[0]['index']];
                    },
                    label: function (tooltipItems, data) {
                        try {
                            return Math.round(tooltipItems.yLabel).toString().replace(/\B(?=(\d{3})+(?!\d))/g, ' ');
                        } catch (e) {
                            return Math.round(tooltipItems.yLabel);
                        }
                    },
                    footer: function () {
                        return ' TONN';
                    }
                }
            },
            responsive: true,
            maintainAspectRatio: false,
            height: 200
        },

        gearChartOptions: {
            hoverBorderWidth: 20,
            legend: {
                display: true,
                onClick: null,
                position: window.innerWidth >= 768 ? 'right' : 'top',
                align: 'center',
                labels: {
                    usePointStyle: true,
                    fontFamily: 'Open Sans',
                    fontSize: window.innerWidth >= 768 ? 16 : 12,
                    pointStyle: 'circle',
                    padding: window.innerWidth >= 768 ? 20 : 10,
                }
            },
            tooltips: {
                enabled: true,
                mode: 'single',
                titleFontFamily: 'Open Sans',
                titleFontSize: 16,
                titleAlign: 'right',
                bodyFontFamily: 'Open Sans',
                bodyFontSize: 30,
                bodyFontColor: colorPalete.priGold,
                bodyFontStyle: 'bold',
                bodyAlign: 'right',
                footerFontFamily: 'Open Sans',
                footerColor: '#fff',
                footerAlign: 'right',
                caretSize: 10,
                callbacks: {
                    title: function (tooltipItem, data) {
                        return data['labels'][tooltipItem[0]['index']];
                    },
                    label: function (tooltipItems, data) {
                        var value = Math.round(data['datasets'][0]['data'][tooltipItems['index']] / 1000).toString().replace(/\B(?=(\d{3})+(?!\d))/g, ' ');
                        return '  ' + value;
                    },
                    footer: function () {
                        return ' TONN';
                    }
                }
            },
            pieceLabel: {
                //render: function (d) { return d.label + " (" + d.percentage + "%)" },
                render: function (d) {
                    if (d.percentage < 0.5) {
                        return "";
                    }
                    return "  " + Math.round(d.percentage) + "%  ";
                },
                precision: 0,
                overlap: false,
                showActualPercentages: false,
                fontColor: '#000',
                fontSize: 18,
                position: window.innerWidth >= 576 ? 'outside' : 'inside',
                segment: true
            },
            responsive: true,
            maintainAspectRatio: false,
            onClick: (evt, item) => {
                let index = item[0]["_index"];
                let name = item[0]["_chart"].data.labels[index];
                let votes = item[0]["_chart"].data.datasets[0].data[index];
                console.log(name);
                console.log(votes);
            }
        },

        functionsInExecution: [],
    },

    watch: {
        fishDataArray: function (val) {
            // console.log(val);
        },

        selectedFish: function (val) {
            val != null? val.Key : null
            this.resetDropdowns(4);
        },

        selectedCondition: function (val) {
            this.resetDropdowns(3);
        },

        selectedConservation: function (val) {
            this.resetDropdowns(2);
        },

        selectedWeight: function (val) {
            this.resetDropdowns(1);
        },

        selectedQuality: function (val) {
            this.resetDropdowns(0);
        },

        selectedArea: function (val) {
            this.resetDropdowns(0);
        },

        selectedGear: function (val) {
            this.resetDropdowns(0);
        },

        selectedQuota: function (val) {
            this.resetDropdowns(0);
        },

        functionsInExecution: function (val) {
            // console.log(val);
        },

        showYTDData: function (val) {
            this.clearData();
        }
    },

    computed: {
        selectedYears: function () {
            return this.fishDataArray.map(x => x.Year);
        },

        selectedFishId: function () {
            if (this.selectedFish !== null) {
                return this.selectedFish.Key;
            }
            return null;
        },

        selectedConditionId: function () {
            if (this.selectedCondition !== null) {
                return this.selectedCondition.map(q => q.Key).join();
            }
            return null;
        },

        selectedConservationId: function () {
            if (this.selectedConservation !== null) {
                return this.selectedConservation.Key;
            }
            return null;
        },

        rekeFilteredConservations: function () {
            if (this.selectedFishCode === 2524 ) {
                return this.conservationOptions.filter(function (obj) {
                    return obj.Code !== 5;
                });
            }
            return this.conservationOptions;
        },

        selectedWeightId: function () {
            if (this.selectedWeight !== null) {
                return this.selectedWeight.map(q => q.Key).join();
            }
            return null;
        },

        selectedQualityId: function () {
            if (this.selectedQuality !== null) {
                return this.selectedQuality.map(q => q.Key).join();
            }
            return null;
        },

        selectedAreaId: function () {
            if (this.selectedArea !== null) {
                return this.selectedArea.map(q => q.Key).join();
            }
            return null;
        },

        selectedGearId: function () {
            if (this.selectedGear !== null) {
                return this.selectedGear.map(q => q.Key).join();
            }
            return null;
        },

        selectedQuotaId: function () {
            if (this.selectedQuota !== null) {
                return this.selectedQuota.Key
            }
            return null;
        },

        selectedFishCode: function () {
            if (this.selectedFish !== null) {
                return this.selectedFish.Code;
            }
            return null;
        },

        selectedConditionCode: function () {
            if (this.selectedCondition !== null) {
                return this.selectedCondition.map(q => q.Code).join();
            }
            return null;
        },

        selectedConservationCode: function () {
            if (this.selectedConservation !== null) {
                return this.selectedConservation.Code;
            }
            return null;
        },

        selectedWeightCode: function () {
            if (this.selectedWeight !== null) {
                return this.selectedWeight.map(q => q.Code).join();
            }
            return null;
        },

        selectedQualityCode: function () {
            if (this.selectedQuality !== null) {
                return this.selectedQuality.map(q => q.Code).join();
            }
            return null;
        },

        isInvalid: function() {
            if (this.selectedFish && (!this.selectedCondition || this.selectedCondition.length === 0) && (!this.selectedConservation || !this.selectedConservation === 0)) {
                return true;
            }
        },

        yearsToCompare: function () {
            if (this.fishDataArray.length > 0) {
                return [... new Set(this.fishDataArray.map(value => value.Year))]
            }
        },

        barCompareDynamicData: function () {
            return {
                labels: this.compareBarCharData.Labels,
                datasets: [
                    {
                        label: this.showYTDData ? 'Samme periode' : 'Total pr år',
                        backgroundColor: this.compareBarCharData.Colors,
                        pointBackgroundColor: 'white',
                        borderWidth: 1,
                        barPercentage: this.compareBarCharData.Labels.length > 1 ? 0.4 : 0.3,
                        pointBorderColor: '#249EBF',
                        data: this.compareBarChartToDateValues.Array,
                    },
                    {
                        label: '',
                        backgroundColor: this.compareBarCharData.Colors,
                        pointBackgroundColor: 'white',
                        borderWidth: 1,
                        barPercentage: this.compareBarCharData.Labels.length > 1 ? 0.4 : 0.3,
                        pointBorderColor: '#249EBF',
                        data: this.compareBarCharData.Data,
                    }
                ]
            }
        },

        baChartComputedOptions: function () {
            return {
                title: {
                    display: true,
                    text: this.compareBarCharData ? this.compareBarCharData.Text : "MRD NOK",
                    fontFamily: 'Open Sans',
                    fontSize: 16,
                    fontColor: colorPalete.priBlue
                },
                scales: {
                    yAxes: [{
                        stacked: true,
                        ticks: {
                            beginAtZero: true
                        },
                        gridLines: {
                            display: false
                        }
                    }],
                    xAxes: [{
                        stacked: false,
                        ticks: {
                            beginAtZero: true,
                        },
                        gridLines: {
                            display: true
                        }
                    }
                    ]
                },
                legend: {
                    display: this.fishDataArray.length > 1? true : false,
                    position: 'bottom',
                    labels: {
                        usePointStyle: false,
                        fontFamily: 'Open Sans',
                        fontSize: window.innerWidth >= 768 ? 14 : 12,
                        pointStyle: 'circle',
                        boxWidth: 0
                    }
                },
                tooltips: {
                    enabled: true,
                    mode: 'single',
                    displayColors: false,
                    titleFontFamily: 'Open Sans',
                    titleFontSize: 16,
                    titleAlign: 'right',
                    bodyFontFamily: 'Open Sans',
                    bodyFontSize: 30,
                    bodyFontColor: colorPalete.priGold,
                    bodyFontStyle: 'bold',
                    bodyAlign: 'right',
                    footerFontFamily: 'Open Sans',
                    footerColor: '#fff',
                    footerAlign: 'right',
                    caretSize: 10,
                    callbacks: {
                        title: function (tooltipItem, data) {
                            return data['labels'][tooltipItem[0]['index']];
                        },
                        label: function (tooltipItem, data) {
                            return '  ' + tooltipItem.xLabel;
                        },
                        footer: function () {
                            return "";
                        }
                    }
                },
                responsive: true,
                maintainAspectRatio: false,
                //onClick: (evt, item) => {
                //    let index = item[0]["_index"];
                //    let year = item[0]["_chart"].data.labels[index];
                //    let votes = item[0]["_chart"].data.datasets[0].data[index];
                //    var event = new CustomEvent("setYear", { 'detail': year }); //set year on bar click

                //    // Dispatch/Trigger/Fire the event
                //    document.dispatchEvent(event);
                //},
                height: this.fishDataArray.length > 1? this.fishDataArray.length * 100 : 140
            }
        },

        compareBarCharData() {
            if (this.compareFishTotalValue) {
                var dynamicLabels = this.yearsToCompare;
                var dynamicBarData = this.compareFishTotalValue.Array;
                var dynamicBarColors = colors;
                var dynamicText = this.compareFishTotalValue.Text;
                return {
                    Labels: dynamicLabels,
                    Data: dynamicBarData,
                    Colors: dynamicBarColors,
                    Text: dynamicText
                }
            }
            return null;
        },

        compareBarChartToDateValues: function () {
            var self = this;

            if (self.fishDataArray.length > 0) {
                return self.$options.filters.scaleArray(self.fishDataArray.map(x => x.ValueToDate), self.compareFishTotalValue.Scale);
            }
            return null;
        },

        fishPriceDynamicData: function () {
            if (this.fishDataArray.length > 0) {
                this.fishDataArray.map((element, index) => {
                    console.log(monthNumbers.map(m => element.Data.filter(({ Month }) => Month === m).reduce((sum, { Price, Quantity }) => sum + (Price * Quantity), 0)));
                    console.log(monthNumbers.map(m => element.Data.filter(({ Month }) => Month === m).reduce((sum, { Quantity }) => sum + Quantity, 0)));
                    }
                   )


                return {
                        labels: months,
                        datasets: 
                            this.fishDataArray.map((element, index) => 
                            ({
                                barPercentage: 0.4,
                                label: element.Year,
                                backgroundColor: '#ffffff00',
                                pointBackgroundColor: 'white',
                                borderWidth: 3,
                                borderColor: colors[index],
                                pointBorderColor: colors[index],
                                data: monthNumbers.map((m, index) => element.Data.filter(({ Month }) => Month === m).reduce((sum, { Price, Quantity }) => sum + (Price * Quantity), 0) / element.Data.filter(({ Month }) => Month === m).reduce((sum, { Quantity }) => sum + Quantity, 0))
                            }))
                    }
            }

            return null;
        },

        fishWightDynamicData: function () {
            if (this.fishDataArray.length > 0) {
                return {
                        labels: months,
                        datasets: 
                            this.fishDataArray.map((element, index) => 
                            ({
                                barPercentage: 0.4,
                                label: element.Year,
                                backgroundColor: colors[index],
                                pointBackgroundColor: 'white',
                                borderWidth: 1,
                                pointBorderColor: '#249EBF',
                                data: monthNumbers.map(m => element.Data.filter(({ Month }) => Month === m).reduce((sum, { Quantity }) => sum + Quantity / 1000, 0))
                            }))
                    }
            }

            return null;
        },

        gearDynamicData: function () {
            if (this.gearDataArray.length > 0) {
                return this.gearDataArray.map((element, index) => 
                ({
                    hoverBackgroundColor: "red",
                    hoverBorderWidth: 10,
                    labels: element.Data.filter(td => td.Value > 0).map(td => td.Name[0] + td.Name.substr(1).toLowerCase()),
                    datasets: [
                        {
                            label: element.Year,
                            backgroundColor: this.orderedChartColors[index].map(x => x.Color),
                            data: element.Data.filter(data => data.Value > 0).map(data => data.Value)
                        }
                    ]
                }));
            }
            return null;
        },

        orderedChartColors: function () {
            var dataSets = this.gearDataArray.map(x => x.Data);
            var colorOrder = [];
            var colorIndex = 0;
            dataSets.forEach(function(dataSet) {
                dataSet.forEach(function(data) {
                    if (!(colorOrder.some(x => x.Name == data.Name))) {
                        colorOrder.push({'Name' : data.Name, 'Color' : colors[colorIndex]});
                        colorIndex++;
                    }
                });
            });
            var output = dataSets.map(x => x.map(y => ({'Name' : y.Name, 'Color' : colorOrder.find(z => z.Name == y.Name).Color })))
            return output;
        },

        fishTotalWeights: function () {
            if (this.fishDataArray.length > 0) {
                var totalWeights = this.fishDataArray.map((element) => ({Year : element.Year, Weight : element.Data.map(x =>x.Quantity / 1000).reduce((a, b) => a + b, 0)}));
                return totalWeights;
            }
            return null;
        },

        allFishTotalWeight: function () {
            if (this.fishDataArray.length > 0) {
                var totalWeight = this.fishTotalWeights.reduce((n, {Weight}) => n + Weight, 0);
                return totalWeight;
            }
            return 0;
        },

        compareFishTotalValue: function () {
            var self = this;
            var compareArray = [];

            if (self.fishDataArray.length > 0) {
                self.fishDataArray.forEach(function (element) {
                    var yearValues = element.Data.map(sfd => (sfd.Price * sfd.Quantity ));
                    var sum1 = yearValues.reduce((a, b) => a + b, 0);
                    compareArray.push(self.$options.filters.round(sum1));
                });
                return self.$options.filters.scaleArray(compareArray);
            }
            return null;
        },

        isGetFishDataInExecution() {
            var self = this;
            return self.functionsInExecution.some(str => str.includes(self.getFishData.name))
        },

        isGetGearDataInExecution() {
            var self = this;
            return self.functionsInExecution.some(str => str.includes(self.getGearData.name));
        },
    },

    methods: {
        selectYear: function (year) {
            var self = this;
            if(!self.selectedYears.includes(year)) {
                self.getFishData(self.selectedFishId, year);
            }
            else {
                self.fishDataArray = self.fishDataArray.filter((element) => element.Year !== year);
                self.gearDataArray = self.gearDataArray.filter((element) => element.Year !== year);
            }
        },

        getStartDate: function (year) {
            return moment([year]).startOf("year").format("YYYYMMDD");
        },

        getEndDate: function (year) {
            var self = this;
            var todaysDate = moment();
            return self.showYTDData?  todaysDate.year(year).format("YYYYMMDD") : moment([year]).endOf("year").format("YYYYMMDD"); 
        },

        getFishTypes: function () {
            var self = this;
            self.fishOptionsLoading = true;
            axios.get('/umbraco/Surface/Statistic/GetFishTypes/', {
                params: {
                    startDate: self.dateRange.start,
                    endDate: self.dateRange.end
                }
            })
                .then((response) => {
                    self.fishOptionsLoading = false;
                    if (response.data !== 'error') {
                        self.fishOptions = response.data;
                    }
                    else {
                        self.displayErrorNotification('Databasefeil, vennligst prøv igjen senere.')
                        console.log('error');
                    }
                })
                .catch(function (error) {
                    self.fishOptionsLoading = false;
                    console.log(error);
                });
        },

        getFishConditions: function () {
            var self = this;
            self.selectedCondition = null;
            self.conditionOptions = [];
            self.fishConditionsLoading = true;
            axios.get('/umbraco/Surface/Statistic/GetFishConditions/', {
                params: {
                    startDate: self.dateRange && self.dateRange.start,
                    endDate: self.dateRange && self.dateRange.end,
                    fishId: self.selectedFish && self.selectedFish.Key,
                    conditionId: null,
                    conservationId: self.selectedConservation && self.selectedConservation.Key,
                    weightId: self.selectedWeight && self.selectedWeight.Key,
                }
            })
                .then((response) => {
                    self.fishConditionsLoading = false;
                    if (response.data !== 'error') {
                        self.conditionOptions = response.data;
                    }
                    else {
                        self.displayErrorNotification('Databasefeil, vennligst prøv igjen senere.')
                        console.log('error');
                    }
                })
                .catch(function (error) {
                    self.fishConditionsLoading = false;
                    console.log(error);
                });
        },

        getFishConservations: function () {
            var self = this;
            self.selectedConservation = null;
            self.conservationOptions = [];
            self.conservationOptionsLoading = true;
            axios.get('/umbraco/Surface/Statistic/GetFishConservations/', {
                params: {
                    startDate: self.dateRange && self.dateRange.start,
                    endDate: self.dateRange && self.dateRange.end,
                    fishId: self.selectedFishId,
                    conditionId: self.selectedConditionId,
                    conservationId: null,
                    weightId: self.selectedWeightId,
                }
            })
                .then((response) => {
                    self.conservationOptionsLoading = false;
                    if (response.data !== 'error') {
                        self.conservationOptions = response.data;
                    }
                    else {
                        self.displayErrorNotification('Databasefeil, vennligst prøv igjen senere.')
                        console.log('error');
                    }
                })
                .catch(function (error) {
                    self.conservationOptionsLoading = false;
                    console.log(error);
                });
        },

        getFishWeights: function () {
            var self = this;
            self.selectedWeight = null;
            self.weightOptions = [];
            self.weightOptionsLoading = true;
            axios.get('/umbraco/Surface/Statistic/GetFishWeights/', {
                params: {
                    startDate: self.dateRange && self.dateRange.start,
                    endDate: self.dateRange && self.dateRange.end,
                    fishId: self.selectedFishId,
                    conditionId: self.selectedConditionId,
                    conservationId: self.selectedConservationId,
                    weightId: null,
                }
            })
                .then((response) => {
                    self.weightOptionsLoading = false;
                    if (response.data !== 'error') {
                        self.weightOptions = response.data;
                    }
                    else {
                        self.displayErrorNotification('Databasefeil, vennligst prøv igjen senere.')
                        console.log('error');
                    }
                })
                .catch(function (error) {
                    self.weightOptionsLoading = false;
                    console.log(error);
                });
        },

        getFishQualities: function () {
            var self = this;
            self.selectedQuality = null;
            self.qualityOptions = [];
            self.qualityOptionsLoading = true;
            axios.get('/umbraco/Surface/Statistic/GetFishQualities/', {
                params: {
                    startDate: self.dateRange && self.dateRange.start,
                    endDate: self.dateRange && self.dateRange.end,
                    fishId: self.selectedFishId,
                    conditionId: self.selectedConditionId,
                    conservationId: self.selectedConservationId,
                    weightId: self.selectedWeightId,
                }
            })
                .then((response) => {
                    self.qualityOptionsLoading = false;
                    if (response.data !== 'error') {
                        self.qualityOptions = response.data;
                    }
                    else {
                        self.displayErrorNotification('Databasefeil, vennligst prøv igjen senere.')
                        console.log('error');
                    }
                })
                .catch(function (error) {
                    self.qualityOptionsLoading = false;
                    console.log(error);
                });
        },

        getPlaceholder: function (element) {
            if (element === 'fish') {
                if (!this.fishOptionsLoading) {
                    return 'Velg art'
                } 
            }
            else if (element === 'condition') {
                if (!this.fishConditionsLoading) {
                    if (this.selectedConservation !== null) {
                        return 'Alle tilstander'
                    }
                    return 'Velg tilstand'
                }
            }
            else if (element === 'conservation') {
                if (!this.conservationOptionsLoading) {
                    if (Array.isArray(this.selectedCondition) && this.selectedCondition.length > 0) {
                        return 'Alle konserveringer'
                    }
                    return 'Velg konservering'
                }
            }
            else if (element === 'weight') {
                if (!this.weightOptionsLoading) {
                    return 'Alle vektklasser'
                }
            }
            else if (element === 'quality') {
                if (!this.qualityOptionsLoading) {
                    return 'Alle kvaliteter'
                }
            }
            else if (element === 'area') {
                if (!this.areaOptionsLoading) {
                    return 'Alle soner'
                }
            }
            else if (element === 'gear') {
                if (!this.gearOptionsLoading) {
                    return 'Alle redskap'
                }
            }
            else if (element === 'quotas') {
                if (!this.gearOptionsLoading) {
                    return 'Alle kvote'
                }
            }
            return 'Laster inn'
        },

        formatWeight({ Key, Name }) {
            if (Name) {

                if (/^[-][0-9]{1,}.{0,}$/.test(Name)) {
                    return 'Under ' + Name.substring(1).toLowerCase();
                }

                if (/^.{1,}[+].{0,}$/.test(Name)) {
                    return 'Over ' + Name.replace("+", "").toLowerCase();
                }

                if (/^.{1,}[-].{1,}$/.test(Name)) {
                    return Name.toLowerCase();
                }
            }
            return Name;
        },

        getFunctionName: function (name) {
            var self = this;
            return name + 'fish:' + self.selectedFishId + 'cond:' + self.selectedConditionId + 'cons:' + self.selectedConservationId + 'weight:' + self.selectedWeightId + 'qua:' + self.selectedQualityId;
        },

        getFishData: function (fishId, year, dateGrouping = 'Month') {
            var self = this;
            var functionName = self.getFunctionName(self.getFishData.name);
            if (self.functionsInExecution.indexOf(functionName) === -1) {
                self.functionsInExecution.push(functionName);
                axios.get('/umbraco/Surface/Statistic/GetQueryResults/', {
                    params: {
                        startDate: self.getStartDate(year),
                        endDate: self.getEndDate(year),
                        fishId: fishId,
                        fishCode: self.selectedFishCode,
                        conservationId: self.selectedConservationId,
                        conditionId: self.selectedConditionId,
                        weightId: self.selectedWeightId,
                        qualityId: self.selectedQualityId,
                        areaId: self.selectedAreaId,
                        gearId: self.selectedGearId,
                        quotaType: self.selectedQuotaId,
                        dateGrouping: dateGrouping,
                        yearSumData: true,
                    }
                })
                    .then((response) => {
                        if (response.data !== 'error') {
                            self.fishDataArray.push(response.data);
                            self.fishDataArray.sort((a, b) => b.Year - a.Year)

                            setTimeout(() => {
                                self.getGearData(fishId, year);
                            }, 100);
                        }
                        else {
                            console.log('error');
                            self.displayErrorNotification('Databasefeil, vennligst prøv igjen senere.')
                        }
                        self.removeFromExecution(functionName);
                    })
                    .catch(function (error) {
                        console.log(error);
                        self.removeFromExecution(functionName);
                        self.displayErrorNotification('Databasefeil, vennligst prøv igjen senere.')
                    });
            }
        },

        refreshFishData: function () {
            var self = this;
            if (self.selectedFish && !self.isFishDataLoaded) {
                setTimeout(() => {
                    self.getFishData(self.selectedFishId);
                }, 100);
            }
            else if (self.selectedFishId && !self.isGearDataLoaded) {
                setTimeout(() => {
                    self.getGearData(self.selectedFishId);
                }, 100);
            }
        },

        loadFishConditions: function () {
            var self = this;
            if (self.conditionOptions.length === 0) {
                self.getFishConditions();
            }
        },

        loadFishConservations: function () {
            var self = this;
            if (self.conservationOptions.length === 0) {
                self.getFishConservations();
            }
        },

        loadWeights: function () {
            var self = this;
            if (self.weightOptions.length === 0) {
                self.getFishWeights();
            }
        },

        loadQualities: function () {
            var self = this;
            if (self.qualityOptions.length === 0) {
                self.getFishQualities();
            }
        },

        getGearData: function (fishId, year) {
            var self = this;
            var functionName = self.getFunctionName(self.getGearData.name);
            if (self.functionsInExecution.indexOf(functionName) === -1) {
                self.functionsInExecution.push(functionName);
                axios.get('/umbraco/Surface/Statistic/GetGearDistribution/', {
                    params: {
                        year : year,
                        YTDData: self.showYTDData,
                        fishId: self.selectedFishId,
                        fishCode: self.selectedFish.Code,
                        conservation: self.selectedConservationCode,
                        condition: self.selectedConditionCode,
                        weight: self.selectedWeightCode,
                        quality: self.selectedQualityCode,
                        area: self.selectedAreaId,
                        gear: self.selectedGearId,
                        quotaType: self.selectedQuotaId,

                    }
                })
                    .then((response) => {
                        if (response.data !== 'error') {
                            self.gearDataArray.push(response.data);
                            self.gearDataArray.sort((a, b) => b.Year - a.Year)
                        }
                        else {
                            console.log('error');
                            self.displayErrorNotification('Databasefeil, vennligst prøv igjen senere.')
                        }
                        self.removeFromExecution(functionName);
                    })
                    .catch(function (error) {
                        console.log(error);
                        self.removeFromExecution(functionName);
                        self.displayErrorNotification('Databasefeil, vennligst prøv igjen senere.')
                    });
            }   
        },

        loadAreas: function () {
            var self = this;
            if (self.areaOptions.length === 0) {
                self.getAreas();
            }
        },

        getAreas: function () {
            var self = this;
            self.selectedArea = null;
            self.areaOptions = [];
            self.areaOptionsLoading = true;
            axios.get('/umbraco/Surface/Statistic/GetAreas/')
                .then((response) => {
                    self.areaOptionsLoading = false;
                    if (response.data !== 'error') {
                        self.areaOptions = response.data;
                    }
                    else {
                        self.displayErrorNotification('Databasefeil, vennligst prøv igjen senere.')
                        console.log('error');
                    }
                })
                .catch(function (error) {
                    self.areaOptionsLoading = false;
                    console.log(error);
                });
        },

        loadGears: function () {
            var self = this;
            if (self.gearOptions.length === 0) {
                self.getGears();
            }
        },

        getGears: function () {
            var self = this;
            self.selectedGear = null;
            self.gearOptions = [];
            self.gearOptionsLoading = true;
            axios.get('/umbraco/Surface/Statistic/GetGears/', {
                params: {
                    startDate: '',
                    endDate: '',
                    fishId: self.selectedFishId,
                    conditionId: self.selectedConditionId,
                    conservationId: self.selectedConservationId,
                }
            })
                .then((response) => {
                    self.gearOptionsLoading = false;
                    if (response.data !== 'error') {
                        self.gearOptions = response.data;
                    }
                    else {
                        self.displayErrorNotification('Databasefeil, vennligst prøv igjen senere.')
                        console.log('error');
                    }
                })
                .catch(function (error) {
                    self.gearOptionsLoadingss = false;
                    console.log(error);
                });
        },

        loadQuotas: function () {
            var self = this;
            if (self.quotaOptions.length === 0) {
                self.getQuotas();
            }
        },

        getQuotas: function () {
            var self = this;
            self.selectedQuota = null;
            self.quotaOptions = [];
            self.quotaOptionsLoading = true;
            axios.get('/umbraco/Surface/Statistic/GetQuotaTypes/', {
                params: {
                    startDate: self.dateRange && self.dateRange.start,
                    endDate: self.dateRange && self.dateRange.end,
                    fishId: self.selectedFish && self.selectedFish.Key,
                    conditionId: self.selectedCondition && self.selectedCondition.Key,
                    conservationId: self.selectedConservation && self.selectedConservation.Key,
                    weightId: self.selectedWeight && self.selectedWeight.Key,
                }
            })
                .then((response) => {
                    self.quotaOptionsLoading = false;
                    if (response.data !== 'error') {
                        self.quotaOptions = response.data;
                    }
                    else {
                        self.displayErrorNotification('Databasefeil, vennligst prøv igjen senere.')
                        console.log('error');
                    }
                })
                .catch(function (error) {
                    self.quotaOptionsLoading = false;
                    console.log(error);
                });
        },


        isFunctionInExecution: function (functionName) {
            var self = this;
            if (self.functionsInExecution.length > 0)
                return self.functionsInExecution.some(str => str.includes(functionName));
            return false;
        },

        displayErrorNotification(error) {
            this.$snotify.error(error, {
                timeout: 5000,
                showProgressBar: true,
                closeOnClick: true,
                pauseOnHover: true
            });
        },

        removeFromExecution(functionName) {
            var self = this;
            const index = self.functionsInExecution.indexOf(functionName);
            if (index > -1) {
                self.functionsInExecution.splice(index, 1);
            }
        },

        showDataLoader(container) {
            var self = this;
            var loader = self.$loading.show({
                container: self.$refs[container],
                loader: 'spinner',
                color: '#007bff',
                isFullPage: false
            });
            return loader;
        },

        resetDropdowns: function (number) {
            var self = this;
            if (number > 4) {
                self.selectedFish = null;
            }
            if (number > 3) {
                self.selectedCondition = null
                self.conditionOptions = []
            }
            if (number > 2) {
                self.selectedConservation = null
                self.conservationOptions = []
            }
            if (number > 1) {
                self.selectedWeight = null
                self.weightOptions = []
            }
            if (number > 0) {
                self.selectedQuality = null;
                self.qualityOptions = [];
                self.selectedArea = null;
                self.selectedGear = null;
                self.gearOptions = [];
            }
            self.clearData();
        },

        clearData() {
            var self = this;
            self.selectedYears = [];
            self.fishDataArray = [];
            self.gearDataArray = [];
        },

        update(data) {
            console.log(data);
        },

        closeDropdown(multiselectElement) {
            var self = this;
            self.$refs[multiselectElement].deactivate(); 
        },
    },

    created() {
        var self = this
        self.multiSelectOptions = multiSelectOptions;
        document.addEventListener("setYear", function (e) {
            //console.log(e.detail);
            self.selectYearData(e.detail)
        });
    },

    mounted() {
        // this.getFishTypes();
    }
});


// WEBPACK FOOTER //
// ./Scripts/app/statisticBank/index.js